import {SET_PROPERTY_TYPE_IMAGE_URL} from './action-types';
import {getPrefix} from '../utils/urls';

export function setPropertyTypesImages(payload) {
    return {
        type: SET_PROPERTY_TYPE_IMAGE_URL,
        payload
    };
}

export function fetchImagesByTags(items = []) {
    return (dispatch) => {
        const tag = items.map((item) => `tags=${item.messageKey}`).join('&');

        const pathName = `/${getPrefix()}/api/property-type-images?${tag}`;

        return fetch(pathName, {
            credentials: 'same-origin'
        }).then((res) => {
            if (!res.ok) {
                return res.json();
            }

            return res.json();
        }).then((payload) => {
            if (payload && Array.isArray(payload)) {
                dispatch(setPropertyTypesImages(payload));
            }
        }).catch((err) => console.log(err)); // eslint-disable-line no-console
    };
}
